export default __webpack_public_path__ + "static/media/Miter of the Judgment Bolt.3f20b999.jpg";